// NPM
import React, { useState, useEffect } from "react";
import _ from "lodash";

// State
import { useSelector } from "react-redux";

// api
import api from "./api";

// Services
import renderService from "services/renderService";
import scrollService from "services/scrollService";

function LastUpdated() {
  // State
  const [timeSeriesData, setTimeSeriesData] = useState([]);
  const campaignConfig = useSelector((state) => state.campaignConfig.value);

  const loadData = async () => {
    const timeSeriesApiData = await api.loadTimeSeriesData();
    setTimeSeriesData(timeSeriesApiData);
  };

  // Hooks
  useEffect(() => loadData(), []);

  if (!renderService.canRender([campaignConfig, timeSeriesData])) {
    return null;
  }

  const titlePart = _.get(campaignConfig, "sections.LastUpdated.title");
  // Parse and re-create a date to correctly handle the timezone
  const latestEntry = timeSeriesData[0].date;
  const [year, month, day] = latestEntry.split("-").map((num) => parseInt(num));
  const title = `${titlePart} ${new Date(year, month - 1, day).toLocaleDateString("en-CA", { month: "long", day: "numeric", year: "numeric" })}`;
  const linkText = _.get(campaignConfig, "sections.LastUpdated.linkText");

  return (
    <div className="LastUpdated">
      <p>{title}</p>
      <a onClick={() => scrollService.scrollToId("Changelog")}>{linkText}</a>
    </div>
  );
}

export default LastUpdated;
